import React from 'react';

import { AnyAction } from 'redux';
import { Export } from '~/Api/User/ProductGroup';
import { ThunkAction } from '~/Store';
import { selectProductById } from '~/Product';
import downloadFileFromUrl from '~/utils/Download/downloadFileFromUrl';
import { flashSuccessMessage } from '~/FlashMessage';

export function buildErrorLocation(productErrors: Array<{ productId: string | null }>): ThunkAction<string, AnyAction> {
	return (dispatch, getState) => {
		const { products } = getState();
		const productNames = productErrors
			.map((error) => {
				const product = selectProductById(products, error.productId);
				return product ? `${product.brandName} (${product.dataset.source.country.alpha2})` : null;
			})
			.filter((name) => name !== null);
		return productNames.length > 0 ? `, please check products: ${productNames.join(', ')}` : '';
	};
}

export const processExport = (fileExport: Export): ThunkAction<void, any> => {
	return (dispatch) => {
		if (fileExport.downloadUrl !== null) {
			downloadFileFromUrl(fileExport.downloadUrl);
		} else {
			dispatch(
				flashSuccessMessage(
					<>
						Your export request has been enqueued and once it finishes, you'll receive a notification at your email{' '}
						<strong>{fileExport.asyncNotification.email}</strong> with a download link.
					</>
				)
			);
		}
	};
};
